import styled, { css } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device } from '@/styles/helpers';

export const ScModalEditCurrencies = styled.div<{ isOldVersion?: boolean }>`
  position: relative;
  background: ${({ theme }) => theme.whiteColor};
  width: 100%;
  color: ${({ theme }) => theme.blackColor};

  ${({ isOldVersion }) =>
    isOldVersion
      ? css`
          border-radius: 8px;
          overflow: hidden;
          max-width: 768px;
          margin: 40px auto;
        `
      : css`
          max-width: 640px;
          min-height: 420px;
          border-radius: 24px;
          padding: 16px;
          margin: 40px auto;
          display: flex;
          flex-direction: column;
          gap: 32px;

          & > .top-box {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;

            svg path {
              fill: ${({ theme }) => theme.blackColor};
            }
          }
        `}
`;

export const ScEditCurrenciesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  & > .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;

    button {
      max-width: 280px;
      @media (${device.mobileS}) {
        max-width: 100%;
      }
    }
  }
`;

interface ScCurrencyItemProps {
  isCurrent: boolean;
  noAction: boolean;
  mode?: ThemeMode;
  isActive?: boolean;
}

export const ScCurrencyItem = styled.div<ScCurrencyItemProps>`
  width: 100%;
  min-height: 40px;
  padding: 3px 3px 3px 7px;
  border-radius: 24px;
  position: relative;
  gap: 8px;
  display: grid;
  grid-template-columns: ${({ isCurrent, noAction }) =>
    isCurrent || !noAction ? 'minmax(0, 1fr) auto' : '1fr'};
  color: ${({ theme }) => theme.blackLightColor};
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  cursor: ${({ isActive }) => isActive && 'pointer'};

  .currency-info {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;

    & > svg {
      width: 24px;
      height: 24px;
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .actions {
    gap: 8px;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    & > svg {
      width: 32px;
      height: 32px;
      object-fit: contain;
      flex-shrink: 0;
    }

    & > button {
      flex-shrink: 0;
      min-width: ${({ isActive }) => (isActive ? '85px' : '54px')};
    }
  }

  ${({ mode }) =>
    mode === ThemeMode.Dark
      ? css`
          border: 1px solid rgba(255, 255, 255, 0.2);
        `
      : css`
          background-color: ${({ theme }) => theme.gray1Color};
        `}

  ${({ isCurrent, mode }) =>
    isCurrent &&
    css`
      background-color: ${({ theme }) =>
        mode === ThemeMode.Dark && theme.whiteColor};
      color: ${({ theme }) => theme.blackColor};
    `}


	@media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${({ theme }) => theme.blackColor};
    }
  }
`;
